import { IActionOptions } from '@interfaces/IActionOptions';
import { IUser } from '@interfaces/IUser';
import { IUsersGroup } from '@interfaces/IUsersGroup';
import { Action } from '@ngrx/store';
import { IUserStateErrors } from './user.state';

export enum EUserActions {
  UserInfoLoadingForTabs = '[User]  User Info Loading For Tabs',

  GetUsers = '[User] Get Users',
  GetUsersSuccess = '[User] Get Users Success',
  GetUsersFailure = '[User] Get Users Failure',

  GetUser = '[User] Get User',
  GetUserSuccess = '[User] Get User Success',
  GetUserFailure = '[User] Get User Failure',

  Register = '[User] Register',
  RegisterSuccess = '[User] RegisterSuccess',
  StartRegisterLoading = '[User] Start Register Loading',
  RequestFailure = '[User] Request Failure',
  ConfirmUser = '[User] Confirm User',
  EditUserStartLoading = '[User] Edit User Start Loading',
  ImportUsers = '[User] Import Users',
  ImportUsersFailure = '[User] Import Users Failure',
  ImportUsersSuccess = '[User] Import Users Success',
  ImportSkippedReset = '[User] Import Skipped Reset',
  ImportErrorReset = '[User] Import Error Reset',

  GetUserGroups = '[User] Get Groups',
  GetUserGroupsSuccess = '[User] Get Groups Success',
  GetUserGroupsFailure = '[User] Get Groups Failure',

  CreateUser = '[User] Create User',
  CreateUserSuccess = '[User] Create User Success',
  CreateUserFailure = '[User] Create User Failure',

  EditUser = '[User] Edit User',
  EditUserSuccess = '[User] Edit User Success',
  EditUserFailure = '[User] Edit User Failure',

  DeleteUser = '[User]  Delete User',
  DeleteUserSuccess = '[User]  Delete User Success',
  DeleteUserFailure = '[User]  Delete User Failure',

  GetUnconfirmedCount = '[Users]  Get Unconfirmed Count',
  GetUnconfirmedCountSuccess = '[Users]  Get Unconfirmed Count Success',

  DeleteHappyPoint = '[User] Delete Happy Point',

  ClearStateUsers = '[Users] Clear state users',
}

export class GetUnconfirmedCount implements Action {
  public readonly type = EUserActions.GetUnconfirmedCount;
}

export class UserInfoLoadingForTabs implements Action {
  public readonly type = EUserActions.UserInfoLoadingForTabs;

  constructor(public payload: boolean) {}
}

export class GetUnconfirmedCountSuccess implements Action {
  public readonly type = EUserActions.GetUnconfirmedCountSuccess;

  constructor(public count: number) {}
}

export class DeleteUser implements Action {
  public readonly type = EUserActions.DeleteUser;

  constructor(public id: number, public options?: { navTo?: string }) {}
}

export class DeleteUserSuccess implements Action {
  public readonly type = EUserActions.DeleteUserSuccess;

  constructor(public id: number) {}
}

export class DeleteUserFailure implements Action {
  public readonly type = EUserActions.DeleteUserFailure;
}

export class CreateUser implements Action {
  public readonly type = EUserActions.CreateUser;

  constructor(public user: IUser) {}
}

export class CreateUserSuccess implements Action {
  public readonly type = EUserActions.CreateUserSuccess;

  constructor(public user: IUser) {}
}

export class CreateUserFailure implements Action {
  public readonly type = EUserActions.CreateUserFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export class EditUserStartLoading implements Action {
  public readonly type = EUserActions.EditUserStartLoading;
}

export class ImportUsers implements Action {
  public readonly type = EUserActions.ImportUsers;

  constructor(public data: FormData, public groupId: number) {}
}

export class ImportUsersSuccess implements Action {
  public readonly type = EUserActions.ImportUsersSuccess;

  constructor(public skipped?: { users: string[]; text: string }) {}
}

export class ImportSkippedReset implements Action {
  public readonly type = EUserActions.ImportSkippedReset;
}

export class ImportErrorReset implements Action {
  public readonly type = EUserActions.ImportErrorReset;
}

export class ImportUsersFailure implements Action {
  public readonly type = EUserActions.ImportUsersFailure;

  constructor(public error: { file: string[]; group: string[] }) {}
}

export class EditUser implements Action {
  public readonly type = EUserActions.EditUser;

  constructor(
    public id: number,
    public userData: IUser,
    public options?: { message?: string; navTo?: string }
  ) {}
}

export class EditUserFailure implements Action {
  public readonly type = EUserActions.EditUserFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export class EditUserSuccess implements Action {
  public readonly type = EUserActions.EditUserSuccess;

  constructor(public user: IUser) {}
}

export class ConfirmUser implements Action {
  public readonly type = EUserActions.ConfirmUser;

  constructor(public id: number, public notificationId?: number) {}
}

export class RequestFailure implements Action {
  public readonly type = EUserActions.RequestFailure;

  constructor(public errors: IUserStateErrors) {}
}

export class StartRegisterLoading implements Action {
  public readonly type = EUserActions.StartRegisterLoading;
}

export class RegisterSuccess implements Action {
  public readonly type = EUserActions.RegisterSuccess;
}

export class Register implements Action {
  public readonly type = EUserActions.Register;

  constructor(public user: IUser) {}
}

export class GetUsers implements Action {
  public readonly type = EUserActions.GetUsers;

  constructor(public options?: IActionOptions) {}
}

export class GetUsersSuccess implements Action {
  public readonly type = EUserActions.GetUsersSuccess;

  constructor(public payload: { results: IUser[]; count: number }) {}
}

export class GetUsersFailure implements Action {
  public readonly type = EUserActions.GetUsersFailure;
}

export class GetUser implements Action {
  public readonly type = EUserActions.GetUser;

  constructor(public id: number) {}
}

export class GetUserSuccess implements Action {
  public readonly type = EUserActions.GetUserSuccess;

  constructor(public payload: IUser) {}
}

export class GetUserFailure implements Action {
  public readonly type = EUserActions.GetUserFailure;
}

export class GetUserGroups implements Action {
  public readonly type = EUserActions.GetUserGroups;
}

export class GetUserGroupsSuccess implements Action {
  public readonly type = EUserActions.GetUserGroupsSuccess;

  constructor(public payload: IUsersGroup[]) {}
}

export class GetUserGroupsFailure implements Action {
  public readonly type = EUserActions.GetUserGroupsFailure;
}

export class DeleteHappyPoint implements Action {
  public readonly type = EUserActions.DeleteHappyPoint;

  constructor(public period: number) {}
}

export class ClearStateUsers implements Action {
  public readonly type = EUserActions.ClearStateUsers;
}

export type UserActions =
  | GetUsers
  | GetUser
  | GetUserSuccess
  | GetUserFailure
  | GetUsersSuccess
  | Register
  | RequestFailure
  | ConfirmUser
  | StartRegisterLoading
  | RegisterSuccess
  | EditUserStartLoading
  | EditUser
  | EditUserSuccess
  | EditUserFailure
  | ImportUsers
  | ImportUsersFailure
  | ImportUsersSuccess
  | ImportSkippedReset
  | ImportErrorReset
  | GetUserGroups
  | GetUserGroupsSuccess
  | GetUserGroupsFailure
  | CreateUser
  | CreateUserFailure
  | CreateUserSuccess
  | DeleteUser
  | DeleteUserSuccess
  | DeleteUserFailure
  | GetUsersFailure
  | GetUnconfirmedCount
  | GetUnconfirmedCountSuccess
  | DeleteHappyPoint
  | ClearStateUsers
  | UserInfoLoadingForTabs;
